import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { ActiveDataRoomUser, Guid } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useGetDataRoomUserByUserQuery(
	dataRoomGuid?: Guid | undefined,
	userGuid?: Guid | null | undefined,
	forceParent: boolean = false,
	options?:
		| Omit<UseQueryOptions<ActiveDataRoomUser, unknown, ActiveDataRoomUser, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.GetByUser(dataRoomGuid, userGuid),
		() =>
			AxiosUtils.getResponseData<ActiveDataRoomUser>(
				api.get(CerebroApiEndpoints.DataRoomUsers.GetByUser(dataRoomGuid, userGuid), {
					params: { forceParent },
				})
			),
		options
	);
}
